import React from 'react';
import logo from './logo.svg';
import './App.css';
import { useState } from 'react';
import GetStarted from './GetStarted.js';
import Question from './Question.js';

import EmojiView from './EmojiView.js';
import Mistakes from './Mistakes.js';
import QuestionModel from './QuestionModel.js';
import { motion } from "framer-motion";
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTable } from '@fortawesome/free-solid-svg-icons'
import { faCog } from '@fortawesome/free-solid-svg-icons'
import { faVideo } from '@fortawesome/free-solid-svg-icons'
import { faLink } from '@fortawesome/free-solid-svg-icons'
import { faBook } from '@fortawesome/free-solid-svg-icons'
import { faAndroid } from '@fortawesome/free-brands-svg-icons'
import ReactGA from 'react-ga';

import soundfile from './data/ding_cropped.mp3'
import data from './data/proverbs.json';
import fb from './images/fb.png' // relative path to image 

//import usePortal from 'react-cool-portal';

var showQuestion = false;

class App extends React.Component {
  
	constructor(props) {
		super(props);

		this.handleAnswer = this.handleAnswer.bind(this);
		//this.Portal = usePortal();
		
		this.state = {
			showQuestion: false,
			showGetStarted: true,
			displayAnimations : true,
			keyCounter: 0,
			correctTotal: 0,
			grownUpMode: false,
			soundEnabled: true,
			missedQuestions: [],
			questionSource: "proverbs"
		};
		
		ReactGA.initialize('UA-171064856-1');
	}
	
	componentDidMount(){
		document.title = "Test Your Wisdom";
		document.subtitle = "Test and grow your understanding from the best";
	}
	
	handleAnswer(result, reference) {
		let emoji = this.state.emoji;	

		if (result === true) {
			
			if (this.state.soundEnabled) {
				let audio = new Audio(soundfile);
				audio.play();
			}
			
			let newVal = this.state.correctTotal + 1;
			this.setState({correctTotal : newVal});
		} else {
			var missedQuestions = this.state.missedQuestions;
			if (!missedQuestions.includes(reference)) {
				missedQuestions.push(reference);
			}
		
			let newVal = this.state.correctTotal;
			
			if (newVal === 0 || newVal === 1)
				newVal = 0;
			else if (newVal <= 3) {
				newVal = 1;
			} else {
				newVal = (newVal * .1);
				newVal = Math.floor(newVal);
			}
			this.setState({correctTotal : newVal});
		}
		this.setState({keyCounter: this.state.keyCounter + 1});
	}
	
  render() {
	  let mainDisplay = this.state.question;
	  let correctTotal = this.state.correctTotal;
	  let questionSource = this.state.questionSource;
	  //alert('questionSource: ' + questionSource);
	  var myQuestionModel = new QuestionModel(this.state.grownUpMode, questionSource);
	  let questionsCount = myQuestionModel.getQuestionCount();
	  let displayAnimation = true;
	  let initial = { scale: 0};
	  let grownUpMode = this.state.grownUpMode;
	  let missedQuestions = this.state.missedQuestions;
	  if (displayAnimation) {
		  initial = { scale: 0 };
	  } else {
		  initial = false;
	  }
	  
	  return (	  
		<div className="App background-wood">

		
			<audio id="ding">
			  <source src="./data/ding_cropped.mp3" type="audio/mpeg"/>
			  Your browser does not support the audio element.
			</audio>
		
			<header className="App-header">
				<link href="https://fonts.googleapis.com/css2?family=Merriweather:wght@300;400&display=swap" rel="stylesheet"/>
				<h1>Test Your Wisdom </h1>
			</header>
			
			<p>
				<EmojiView correctQuestionCount={correctTotal}/>
			</p>
			
			<div className="slide-down">
				<div key="{this.state.keyCounter}" >
					<motion.div
						className="card container" 
						initial={initial}
						animate={{ rotate: 360, scale: 1 }}
						transition={{
						type: "spring",
						stiffness: 260,
						damping: 20
						}}
					>
						<Question onAnswer={this.handleAnswer} grownUpMode={grownUpMode} correctQuestionCount={correctTotal} questionSource={questionSource}/>
					</motion.div>
				</div>
			</div>

			<header className="Sub-header">
				<p>
				  We've taken {questionsCount} sections from the book of Proverbs and presented them as multiple choice questions. Don't just assume you are wise! Ask God for it and test yourself.
				</p>
			</header>
			
			<br/>
						
			<Mistakes missedQuestions={missedQuestions}/>
			
			<br/>
			
			<header className="Sub-header">				
				<p>
					<div className="float-left" alt="settings cog"><FontAwesomeIcon icon={faCog} /></div>
					<div className="float-left indent"> Settings </div>
					<div className="small-text float-left indent lower">
						<input type="checkbox"
						
						onClick={() => {
							//				alert('setting to: ' + !this.state.grownUpMode);
											this.setState({
											  grownUpMode: !this.state.grownUpMode,
											});
										}}
						
						/> Grown up mode <br/>
					</div>
					<div className="small-text float-left indent lower">
						<input type="checkbox"
						
												onClick={() => {
											this.setState({
											  soundEnabled: !this.state.soundEnabled,
											});
										}}
						
						/> Disable sound effects <br/>
					</div>
					<div className="small-text float-left indent lower">
						Source: <select name="book" id="book"
						
												onChange={e => {
											this.setState({
											  questionSource: e.target.value,
											  correctTotal: 0
											});
										}}
						
						>
							<option value="proverbs">Proverbs</option>
							<option value="james">James</option>
							<option value="all">All</option>
						</select>
						<br/>
					</div>
				</p>
			</header>
						
			<br/>
			
			<div className="card-static">
				<header>
					<div className="line-static">
					Be wise as serpents <br/>and innocent as doves.
					</div>
					<div class="blueline"/>
					<div className="line-static">
						Matthew 10:6b ESV
					</div>
				</header>
			</div>
			
			<br/>
			
			<div>
				<a href='https://play.google.com/store/apps/details?id=com.proverbstest&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/></a>
			</div>
			
			<br/>
			
			<header className="Sub-header">
				<p>
					<div className="float-left" alt="links"><FontAwesomeIcon icon={faLink} /></div>
					
					<div className="float-left indent"> Links </div>
					
				{/*	<br className="clear-both"/>
					
					<div className="float-left squeeze">
						<a href="https://play.google.com/store/apps/details?id=com.proverbstest">
							<FontAwesomeIcon icon={faAndroid} />
						</a>
					</div>
					<div className="float-left indent">
						<a href="https://play.google.com/store/apps/details?id=com.proverbstest" alt="link to android app page">
							Android App Store
						</a>
				</div>   */}
					
					<br className="clear-both"/>
					
					<div className="float-left squeeze">
						<a href="https://www.facebook.com/Test-Your-Wisdom-103729518038502/?modal=admin_todo_tour">
							<img width="80%" height="80%" src={fb} alt="link to facebook page"/>
						</a>
					</div>
					<div className="float-left indent">
						<a href="https://www.facebook.com/Test-Your-Wisdom-103729518038502/?modal=admin_todo_tour" alt="link to facebook page">
							Our Facebook Site
						</a>
					</div>
					
					<br className="clear-both"/>
					
					<div className="float-left" alt="youtube video 1"><FontAwesomeIcon icon={faVideo} /></div>
					<div className="float-left indent">
						<a href="https://youtu.be/AzmYV8GNAIM" alt="Bible Project Video Proverbs Overview">Bible Project: Proverbs Overview</a>
					</div>
					
					<br className="clear-both"/>
					
					<div className="float-left" alt="youtube video 2"><FontAwesomeIcon icon={faVideo} /></div>
					<div className="float-left indent">
						<a href="https://youtu.be/Gab04dPs_uA" alt="Bible Project Video The Book of Proverbs">Bible Project: The Book of Proverbs</a>
					</div>
					
					{/*		<div className="float-left link-box">
						<iframe alt="Bible project overview video of Proverbs" width="560" height="315" src="https://www.youtube.com/embed/AzmYV8GNAIM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						<br/>
						Read the book of Proverbs <a href="https://www.biblegateway.com/passage/?search=Proverbs%201&version=ESV">here</a> !
					</div>*/}
					
					<br className="clear-both"/>
					
					<div className="float-left" alt="youtube video 1"><FontAwesomeIcon icon={faBook} /></div>
					<div className="float-left indent">
						Read <a href="https://www.biblegateway.com/passage/?search=Proverbs%201&version=ESV">the book of Proverbs</a>
					</div>
					
					
					
					
					<br className="clear-both"/>
					
					<div className="float-left" alt="youtube video 1"><FontAwesomeIcon icon={faBook} /></div>
					<div className="float-left indent">
						<a href="https://www.amazon.com/Mere-Devotion-Micah-Hoover-ebook/dp/B00FO0O3HM/ref=sr_1_1?dchild=1&keywords=%22Mere+Devotion%22&qid=1591310460&sr=8-1"
						alt="Book: Mere Devotion">
							Book Recommendation: Mere Devotion
						</a>
					</div>
					
					
					<br className="clear-both"/>
					
					<div className="float-left" alt="youtube video 1"><FontAwesomeIcon icon={faLink} /></div>
					<div className="float-left indent">
						<a href="https://www.christianitytoday.org/"
						alt="Magazine: Christianity Today">
							Christianity Today
						</a>
					</div>
					
					

					<div className="float-left link-box">	
						
					</div>
				</p>
			</header>	
			
			<br/>
			
			<header className="Sub-header">
				<div className="small-text">
					<p>
						By using our site, you agree to our privacy <a href="../privacy.html">policy</a> and <a href="../terms.html">terms</a>. <a href="mailto:testyourwisdomhelp@gmail.com">Contact</a> us.
					</p>
					<p>
						<a name="esv">
							Scripture quotations are from the ESV® Bible (The Holy Bible, English Standard Version®), copyright © 2001 by Crossway Bibles, a publishing ministry of Good News Publishers. Used by permission. All rights reserved.
						</a>
					</p>
				</div>
			</header>			
			
		</div>

	  );
  }
}

export default App;
